@import '../../../globals/main.scss';

pn-customernumber-selector {
}

.customernumber-container {
  position: relative;
  padding: 0;

  display: flex;
  flex-direction: column;
  border-radius: 0.8rem;
  border: 0.1rem solid $gray400;
  transition: border 0.15s ease;
  &:hover,
  pn-customernumber-selector[open] & {
    border-color: $blue700;
  }

  pn-customernumber-selector[open] & {
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
  }
}

.customernumber-toggle {
  display: flex;
  z-index: 11;
  position: relative;
  margin: 0;
  border-radius: 0.8rem;
  padding: 1rem;
  border: 0;
  background: transparent;
  font-size: 1em;
  text-align: left;
  outline: 0;
  cursor: pointer;

  pn-icon {
    align-self: center;
  }
}

.customernumber-selected {
  flex-grow: 1;
  max-width: calc(100% - 2.4rem);
  overflow: hidden;
}

.customernumber-selected-title {
  color: $blue700;
}

.customernumber-selected-description {
  font-size: 0.875em;
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
}

.customernumber-options {
  position: absolute;
  z-index: 10;
  left: -0.1rem;
  right: -0.1rem;
  top: 100%;
  border: 0.1rem solid $blue700;
  border-bottom-left-radius: 0.8rem;
  border-bottom-right-radius: 0.8rem;

  pn-customernumber-selector[open] & {
    opacity: 1;
    transition-delay: 0s;
    max-height: 500rem;
  }
  max-height: 0;
  opacity: 0;
  transform-origin: top left;
  transition:
    transform 0.2s cubic-bezier(0.6, 0, 0.4, 1) 0.15s,
    opacity 0.1s linear,
    max-height 0.1s ease;
  overflow-y: auto;
}
